import React from 'react'
import PropTypes from 'prop-types'

import { Table } from 'gdpp-components/dist/cjs/components/molecules'

import GridContainer from '../../atoms/FoundationGrid/GridContainer'
import Grid from '../../atoms/FoundationGrid/Grid'
import Cell from '../../atoms/FoundationGrid/Cell'

import './style.scss'

const FundDetailOverviewTab = ({ fundGeneralInfo, fundInfoTable, fundPerformanceTable, fundCodeTable, children }) => {
  return (
    <GridContainer extraClasses="fil-fund-detail__tab-overview">
      {children || (
        <React.Fragment>
          <div className="fil-fund-detail__tab-overview__investment-goal">
            <div
              id="fil-fund-detail__tab-overview__investment-goal-title"
              className="text-heading-s fil-fund-detail__tab-overview__investment-goal-title text-left"
            >
              {fundGeneralInfo.investmentGoalTitle}
            </div>
            <div
              id="fil-fund-detail__tab-overview__investment-goal-content"
              className="text-body-m fil-fund-detail__tab-overview__investment-goal-content text-left"
            >
              {fundGeneralInfo.investmentGoalContent}
            </div>
          </div>
          <Grid extraClasses="fil-fund-detail__tab-overview__introduction">
            <div
              id="fil-fund-detail__tab-overview__introduction-title"
              className="text-heading-s fil-fund-detail__tab-overview__introduction-title"
            >
              {fundGeneralInfo.introductionTitle}
            </div>
            <Cell>
              <Grid>
                <Cell extraClasses="small-12 large-6 fil-fund-detail__first-table-column">
                  <Table id="fil-fund-detail__fund-info-table" {...fundInfoTable} size="small" isAutoFitWidth isScrollable={false} />
                </Cell>
                <Cell extraClasses="small-12 large-6 fil-fund-detail__second-table-column">
                  <Table
                    id="fil-fund-detail__fund-performance-table"
                    {...fundPerformanceTable}
                    isAutoFitWidth
                    size="small"
                    isScrollable={false}
                    extraClasses="fil-fund-detail__fund-performance-table"
                  />
                  <Table
                    id="fil-fund-detail__fund-code-table"
                    {...fundCodeTable}
                    isAutoFitWidth
                    size="small"
                    isScrollable={false}
                    extraClasses="fil-fund-detail__fund-code-table"
                  />
                </Cell>
              </Grid>
            </Cell>
          </Grid>
        </React.Fragment>
      )}
    </GridContainer>
  )
}

FundDetailOverviewTab.propTypes = {
  fundGeneralInfo: PropTypes.object,
  fundInfoTable: PropTypes.object,
  fundPerformanceTable: PropTypes.object,
  fundCodeTable: PropTypes.object,
  isSimpleTable: PropTypes.bool,
  children: PropTypes.any
}

FundDetailOverviewTab.defaultProps = {
  fundGeneralInfo: {},
  fundInfoTable: {},
  fundPerformanceTable: {},
  fundCodeTable: {},
  isSimpleTable: true,
  children: null
}

export default FundDetailOverviewTab
